import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from 'app/core/services/access.service';

@Component({
  selector: 'dialog-add-menu-access',
  templateUrl: './dialog-add-menu-access.component.html',
  styleUrls: ['./dialog-add-menu-access.component.scss']
})
export class DialogAddMenuAccessComponent implements OnInit {

  isLoading: boolean = false;
  menuLoading: boolean = false;

  employeeSubmenuItems = [
    { title: 'Dashboard', icon: 'bar_chart', allowEditDelete: true },
    { title: 'Attendance', icon: 'calendar_today', allowEditDelete: false },
    { title: 'Management', icon: 'manage_accounts', allowEditDelete: true },
    { title: 'Schedule Range', icon: 'schedule', allowEditDelete: true },
    { title: 'Employee Schedule', icon: 'event_note', allowEditDelete: true },
    { title: 'Change Schedule', icon: 'schedule', allowEditDelete: true },
    { title: 'Manpower Planning', icon: 'event_note', allowEditDelete: true },
    { title: 'Leaves', icon: 'send', allowEditDelete: true },
    { title: 'Biometric Verification', icon: 'person', allowEditDelete: false },
    { title: 'Devices', icon: 'devices', allowEditDelete: true }
  ].map(item => ({ ...item, permissions: { view: false, edit: false, delete: false } }));

  payrollExpensesSubmenuItems = [
    { title: 'Time Entries', icon: 'schedule', allowEditDelete: true },
    { title: 'Timesheet', icon: 'pending_actions', allowEditDelete: true },
    { title: 'Generate Employee Fixed Timesheet', icon: 'settings', allowEditDelete: false },
    { title: 'Batch Process Timesheet', icon: 'dynamic_feed', allowEditDelete: false },
    { title: 'Payroll Process', icon: 'payments', allowEditDelete: true },
    { title: 'Payroll Movement', icon: 'payments', allowEditDelete: false },
    { title: 'Generate Payroll', icon: 'settings', allowEditDelete: false },
    { title: 'Employee Payroll', icon: 'payments', allowEditDelete: true },
    { title: 'Loans', icon: 'account_balance', allowEditDelete: true },
    { title: 'Reimbursement', icon: 'account_balance_wallet', allowEditDelete: true },
    { title: 'Deductions', icon: 'tune', allowEditDelete: true },
    { title: 'Adjustments', icon: 'tune', allowEditDelete: true }
  ].map(item => ({ ...item, permissions: { view: false, edit: false, delete: false } }));

  payrollSetupSubmenuItems = [
    { title: 'Access Management', icon: 'settings', allowEditDelete: true },
    { title: 'Account Element', icon: 'settings', allowEditDelete: true },
    { title: 'Charge', icon: 'settings', allowEditDelete: true },
    { title: 'Dep. / Branch / Job', icon: 'settings', allowEditDelete: true },
    { title: 'Holiday', icon: 'settings', allowEditDelete: true },
    { title: 'Payroll Concept', icon: 'settings', allowEditDelete: true },
    { title: 'Payroll Definition', icon: 'settings', allowEditDelete: true },
    { title: 'Salary Scale', icon: 'settings', allowEditDelete: true },
    { title: 'Clients', icon: 'group', allowEditDelete: true },
    { title: 'System Config.', icon: 'settings', allowEditDelete: true }
  ].map(item => ({ ...item, permissions: { view: false, edit: false, delete: false } }));

  reportsSubmenuItems = [
    { title: 'Work Attendance Log', icon: 'summarize', allowEditDelete: false },
    { title: 'Time Tracking Comparison', icon: 'compare_arrows', allowEditDelete: false },
    { title: 'Time Entries Summary', icon: 'summarize', allowEditDelete: false },
    { title: 'Timesheet Summary', icon: 'summarize', allowEditDelete: false },
    { title: 'Leave Summary', icon: 'summarize', allowEditDelete: false },
    { title: 'Payroll Summary', icon: 'summarize', allowEditDelete: false },
    { title: 'Holiday Summary', icon: 'summarize', allowEditDelete: false },
    { title: 'Late Report', icon: 'summarize', allowEditDelete: false },
    { title: 'Undertime Report', icon: 'summarize', allowEditDelete: false },
    { title: 'SSS Alphalist', icon: 'summarize', allowEditDelete: false },
    { title: 'PhilHealth Alphalist', icon: 'summarize', allowEditDelete: false },
    { title: 'Pag-IBIG Alphalist', icon: 'summarize', allowEditDelete: false },
    { title: 'Taxes Withheld', icon: 'summarize', allowEditDelete: false },
    { title: 'Employee DTR', icon: 'today', allowEditDelete: false },
    { title: 'Invalid Timesheet', icon: 'warning', allowEditDelete: false }
  ].map(item => ({ ...item, permissions: { view: false, edit: false, delete: false } }));

  displayedColumns: string[] = ['title', 'view', 'edit', 'delete'];

  constructor(public dialogRef: MatDialogRef<DialogAddMenuAccessComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private accessService: AccessService) { }

  ngOnInit(): void {
    if (this.data?.id) {
      this.menuLoading = true;
      this.accessService.getMenuAccess(this.data.id).subscribe({
        next: (menus) => {
          this.applySavedPermissions(menus);
          this.menuLoading = false;
        },
        error: (err) => {
          console.error('Failed to load menu access:', err);
          this.menuLoading = false;
        }
      });
    }
  }

  private applySavedPermissions(menus: any[]): void {
    const allSubmenuGroups = [
      this.employeeSubmenuItems,
      this.payrollExpensesSubmenuItems,
      this.payrollSetupSubmenuItems,
      this.reportsSubmenuItems
    ];

    for (const group of allSubmenuGroups) {
      for (const item of group) {
        const saved = menus.find(m => m.title === item.title);
        if (saved) {
          item.permissions.view = saved.view;
          item.permissions.edit = saved.edit;
          item.permissions.delete = saved.delete;
        }
      }
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

  isAllChecked(list: any[], key: 'view' | 'edit' | 'delete'): boolean {
    return list.every(item => item.permissions[key]);
  }

  toggleAll(list: any[], key: 'view' | 'edit' | 'delete', checked: boolean): void {
    list.forEach(item => {
      if (key === 'edit' || key === 'delete') {
        if (item.permissions.view && item.allowEditDelete) {
          item.permissions[key] = checked;
        } else {
          item.permissions[key] = false;
        }
      } else if (key === 'view') {
        item.permissions.view = checked;
        if (!checked) {
          item.permissions.edit = false;
          item.permissions.delete = false;
        }
      }
    });
  }

  onViewChange(item: any): void {
    if (!item.permissions.view) {
      item.permissions.edit = false;
      item.permissions.delete = false;
    }
  }

  onConfirm(): void {
    this.isLoading = true;

    this.employeeSubmenuItems.forEach(item => {
      delete item.allowEditDelete;
    });

    this.payrollExpensesSubmenuItems.forEach(item => {
      delete item.allowEditDelete;
    });

    this.payrollSetupSubmenuItems.forEach(item => {
      delete item.allowEditDelete;
    });

    this.reportsSubmenuItems.forEach(item => {
      delete item.allowEditDelete;
    });

    const allSubmenuItems = [
      ...this.employeeSubmenuItems,
      ...this.payrollExpensesSubmenuItems,
      ...this.payrollSetupSubmenuItems,
      ...this.reportsSubmenuItems
    ];

    const filteredPermissions = allSubmenuItems.filter(item => item.permissions.view);

    console.log('Filtered permissions:', filteredPermissions);

    this.accessService.addMenuAccess(this.data.id, filteredPermissions)
      .subscribe({
        next: (response) => {
          console.log('Menu access saved:', response);
          this.isLoading = false;
          this.dialogRef.close(response);
        },
        error: (error) => {
          console.error('Save failed:', error);
          this.isLoading = false;
        }
      });
  }
}
